import { render, staticRenderFns } from "./dataSettings.vue?vue&type=template&id=2ead1a9a&scoped=true"
import script from "./dataSettings.vue?vue&type=script&lang=js"
export * from "./dataSettings.vue?vue&type=script&lang=js"
import style0 from "./dataSettings.vue?vue&type=style&index=0&id=2ead1a9a&prod&lang=scss"
import style1 from "./dataSettings.vue?vue&type=style&index=1&id=2ead1a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead1a9a",
  null
  
)

export default component.exports